

import Show from "./components/show"
import Festival from "./components/festival"
import ShowPreview from "./components/show-preview"
import ShowSimple from "./components/show-simple"
import FestivalPreview from "./components/festival-preview"
import SpecialScreeningPreview from "./components/show-special-screening"

let shows = [
    {
      title: "Come From Away",
      subtitle: "True Story. Hit Musical.",
      date: new Date(2023, 9, 24),
      dateFormatted: "Tuesday October 24th 2023",
      dateFormattedShort: "Oct 24th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Performing Arts Center",
      tickets: "https://www.ticketmaster.com/event/16005EF5DB036A97",
      website: "https://comefromaway.com/",
      trailer: "https://www.youtube.com/watch?v=UCFmoN_2Pu8",
      description: "A remarkable true story of 7,000 stranded passengers and the small town in Newfoundland that welcomed them. Cultures clashed and nerves ran high, but uneasiness turned into trust, music soared into the night, and gratitude grew into enduring friendships.",
      content: `
      This New York Times Critics' Pick takes you into the heart of the remarkable true story of 7,000 
      stranded passengers and the small town in Newfoundland that welcomed them. Cultures clashed and nerves 
      ran high, but uneasiness turned into trust, music soared into the night, and gratitude grew into 
      enduring friendships.
      <p>
      Don't miss this breathtaking musi-cal written by Tony® nominees Irene Sankoff and David Hein, directed 
      by Tony® winning Best Director, Christopher Ashley and musical staging by Tony®-nominee Kelly Devine. 
      The tour is directed by Daniel Goldstein with mu- sical staging by Richard J. Hinds, based on the 
      original Broadway direction and choreography.
      <p>
      Newsweek cheers, “It takes you to a place you never want to leave!”
      <p>
      On 9/11, the world stopped.<br />
      On 9/12, their stories moved us all.<br />
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },
    {
      title: "An Evening With Jon Meacham",
      subtitle: "Hope Through History: How to endure and prevail when everything appears hopeless",
      mastersAtMarshall: true,
      mastersAtMarshallTickets: "https://www.ticketmaster.com/event/16005EF5D2986199",
      date: new Date(2023, 10, 10),
      dateFormatted: "Friday November 10th, 2023",
      dateFormattedShort: "Nov 10th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Performing Arts Center",
      tickets: "https://www.ticketmaster.com/event/16005EFBB208387F",
      website: "https://www.jonmeacham.com/",
      trailer: "https://www.youtube.com/watch?v=GyAly4Q0eB4",
      posterInfo: "Meacham will be signing books after presentation",
      description: "Pulitzer Prize-winning author and Presidential historian Jon Meacham is one of America's most prominent public intellectuals. With a depth of knowledge about politics, history, religion and current affairs, Meacham has the unique ability to bring historical context to issues and events that impact our daily lives.",
      content: `
      Pulitzer Prize-winning author and Presidential historian Jon Meacham is one of America's most prominent public intellectuals. With a depth of knowledge about politics, history, religion and current affairs, Meacham has the unique ability to bring historical context to issues and events that impact our daily lives.
      <p>
      A contributing editor at TIME, Meacham writes for the magazine's “Ideas” section. He also pens “The Long View” column in The New York Times Book Review in which he “looks back at books that speak to our current historical and cultural moment.” He served as Newsweek's managing editor from 1998 to 2006 and editor from 2006 to 2010.
      <p>
      Meacham is the author of multiple New York Times bestsellers including, Songs of America co-written by musician Tim McGraw, which is a celebration of the music that helped shape a nation. Another #1 New York Times bestseller, The Soul of America: The Battle for Our Better Angels, examines the present moment in American politics and life by looking back at critical times in U.S. history when hope overcame division and fear. In 2020, he released, His Truth Is Marching On: John Lewis and the Power of Hope - an intimate and revealing portrait of civil rights icon and longtime U.S. congressman John Lewis and quickly gained bestseller status.
      <p>
      Meacham's Presidential biography of George H. W. Bush, Destiny and Power: The American Odyssey of George Herbert Walker Bush, debuted at #1 on the New York Times bestsellers list. He is a co-author of Impeachment: An American History,
      which reveals the complicated motives behind the three impeachments in U.S. history. A #1 New York Times bestseller, Thomas Jefferson: The Art of Power was hailed as “masterful and intimate” by Fortune magazine. Meacham's other national bestsellers include Franklin and Winston, American Gospel, and American Lion: Andrew Jackson in the White House, which won the Pulitzer Prize in 2009.
      <p>
      Named a “Global Leader for Tomorrow” by the World Economic Forum, he is a member of the Council on Foreign Relations and a fellow of the Society of American Historians. Meacham is a distinguished visiting professor at Vanderbilt University where he holds the Rogers Chair in the American Presidency. His latest book, And There Was Light: Abraham Lincoln and the American Experiment, was published in 2022.
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },
    {
      title: "An Evening With Beth Macy",
      subtitle: null,
      mastersAtMarshall: true,
      mastersAtMarshallTickets: "https://www.ticketmaster.com/event/16005EF5D2986199",
      date: new Date(2024, 1, 22),
      dateFormatted: "Thursday February 22nd 2024",
      dateFormattedShort: "Feb 22nd",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Performing Arts Center",
      tickets: "https://www.ticketmaster.com/event/16005EFBBAED3FD8",
      website: "https://intrepidpapergirl.com/",
      trailer: "https://www.youtube.com/watch?v=N1FrAj6DoFc",
      posterInfo: "Macy will be signing books after presentation",
      description: "Journalist & bestselling author Beth Macy discusses the unraveling of rural America, from the aftermath of globalization to the opioid crisis, the subject of her latest book Raising Lazarus: Hope, Justice, and the Future of America's Overdose Crisis.",
      content: `
      Beth Macy is a Virginia-based journalist who writes about outsiders and underdogs. Raised poor in a small Ohio community, she is the award-winning author of three New York Times bestselling books examining rural communities left behind by corporate greed and political indifference. Her first book, Factory Man, explored the aftermath of globalization and won a J. Anthony Lukas Prize. Dopesick was short-listed for the Carnegie Medal, won the L.A. Times Book Prize for Science and Technology, and was described as a “masterwork of narrative nonfiction” by The New York Times.
      <p>
      Dopesick was made into a Peabody and Emmy Award-winning Hulu series; Macy was an executive producer and 
      co-writer on the show. Her 2022 book, Raising Lazarus: Hope, Justice, and the Future of America's Overdose Crisis, was a follow-up to Dopesick and explored on-the-ground solutions to the nation's drug epidemic.
      <p>
      A 2010 Nieman Fellow for Journalism at Harvard and a 2023 Guggenheim Fellow, Macy has also written for The New York 
      Times, The Wall Street Journal, The Atlantic, and The Washington Post. Her next book, Paper Girl, is a combination 
      memoir and reported examination of the rural-urban divide told through the lenses of declining upward mobility, 
      political polarization, and the decimation of local and regional news.
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },
    {
      title: "PIFF The Magic Dragon",
      subtitle: "50% Comedian. 50% Magician. 100% Dragon.",
      date: new Date(2023, 10, 16),
      dateFormatted: "Thursday November 16th 2023",
      dateFormattedShort: "Nov 16th",
      timeFormatted: "7:30 pm",
      location: "Keith-Albee Performing Arts Center",
      tickets: "https://www.ticketmaster.com/event/16005EF58546158F",
      website: "https://piffthemagicdragon.com/",
      trailer: "https://www.youtube.com/watch?v=cGRTtehUlXY",
      description: `
        “A stunningly good magician” - Penn & Teller<br />
        “A phenomenal talent” - Howard Stern<br />
        “Piff is the best. A true original.” - David Copperfield<br />
      `,
      content: `
        Since breaking out on America's Got Talent, Piff the Magic Dragon has won the heart of America through his Vegas residency, network television appearances and non-stop touring.
        <p>
        For the past five years, Piff has headlined the iconic Flamingo Hotel and Casino in the heart of the Las Vegas strip, with over 250 shows a year in the Piff the Magic Dragon Theatre. In 2020, Piff was crowned the winner of TBS' Tournament of Laughs, triumphing over his heroes Jeff Ross, Natasha Leggero
        and Judah Friedlander. In 2019, he was voted one of Variety's Top Ten Comics to Watch and scooped Best Comedian, Best Magician and Best Headliner at the Best of Las Vegas Awards. Before arriving in Las Vegas, Piff became a viral sensation on Penn & Teller: Fool Us, had eight sell-out seasons at the Edinburgh Fringe, two in the West End and opened for Mumford & Sons, playing to 150,000 people on tour.
        <p>
        Accompanying Piff on his many adventures Mr Piffles (the world's only magic performing chihuahua) has been levitated, laminated, shackled in a
        strait jacket and shot out of a cannon all in the name of entertainment. It was during the Edinburgh Fringe of 2009 that Piff realized he needed a gimmick. He found it the very next day in the shape of an eighteen month old rescue dog named Alfie. Twelve years later and now known as Mr Piffles, he has blossomed into one of the most famous dogs in Las Vegas and the two of them are inseparable.
        <p>
        They may be a double act but it's no secret who the star is.        
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },  
    {
      title: "Banff Mountain Film Festival",
      subtitle: "World Tour",
      date: new Date(2024, 3, 22),
      dateFormatted: "Monday April 22nd 2024",
      dateFormattedShort: "Apr 22nd",
      timeFormatted: "7:00 pm",
      location: "Marshall University Rec Center",
      tickets: "https://www.ticketmaster.com/banff-mountain-film-festival-huntington-west-virginia-04-22-2024/event/16005F25A808152F",
      website: "https://www.banffcentre.ca/banffmountainfestival/tour/us",
      trailer: "https://www.youtube.com/watch?v=9YhV6I8conw",
      description: "The Banff Mountain Film Festival is the most prestigious mountain festival in the world. Featuring the world’s best mountain sport, culture and environmental films, you can experience the thrill and challenges of the mountain environments that inspire us all. These films explore the mountain world, highlighting new landscapes and remote cultures, and exposes audiences to exciting adventures and adrenaline packed sports. Since 1986, right after the festival, held every fall in Banff, Alberta, the Banff Mountain Film Festival World Tour starts to travel around the globe with stops in 450 communities and 40 countries.",
      content: `
        <h3>Festival Films</h3>
        <div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>NO WAY</strong><br />
            <p style="margin: 0px; font-size: 90%;">Jean-Baptiste Chandelier takes his unique low-flying, ground-skimming art combining paragliding and filmmaking to a whole new level.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=No+Way+Fail+FPV+V5.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>SCHOOL OF FISH</strong><br />
            <p style="margin: 0px; font-size: 90%;">Indigenous people and salmon have been intertwined for thousands of years in Bristol Bay, Alaska. For the last century, corporations have sought to extract the wealth of this rich region and now Pebble Mine threatens to pollute its pristine headwaters. Can the next generation step up to defend the most prolific salmon run left on earth?</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=SchoolofFish_Trailer_60s_Horizontal2.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>TO BE FRANK</strong><br />
            <p style="margin: 0px; font-size: 90%;">Frank Paine is a 73-year-old South Bay icon and humble local legend whose life orbits around a two-block stretch of beach. His unforgettable mustache is what most first notice, but his magnetic spirit and unwavering passion are what keeps the Hermosa Beach surf community connected and whole.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=TBF_TRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>WELL WORN LIFE WITH DANI REYES-ACOSTA</strong><br />
            <p style="margin: 0px; font-size: 90%;">Meet Dani Reyes-Acosta: a mountain athlete, land cultivator, and storyteller whose path consistently seeks the limits of her possibility.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=WellWornLifeTRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>THE ASCENSION SERIES: MORAG SKELTON</strong><br />
            <p style="margin: 0px; font-size: 90%;">Morag Skelton doesn't let anything stand in the way of her love of nature. As a deaf climber, she is constantly pushing the limits of what is possible on the mountainside.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=the_ascension_series__morag_skelton_-_promo_clip+(1080p).mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>CHRONOCEPTION</strong><br />
            <p style="margin: 0px; font-size: 90%;">Thomas Delfino, Léa Klaue and Aurélien Lardy, embark on an ambitious expedition in the mountains of Kyrgyzstan to ski the Kok-shaal-Too range. This skilled team, accompanied by renowned guides Hélias Millerioux and Jean-Yves Fredriksen, finds themselves propelled into a space where time seems to have suddenly come to a halt.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=CHRONOCEPTION+TRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>GOING GREENLAND</strong><br />
            <p style="margin: 0px; font-size: 90%;">What happens when you combine a renewable energy sailboat with an artic ski expedition in Greenland for the first time ever? Athletes Rachael Burks and Jessica Baker put the idea to test, and endure a both harrowing and inspiring journey along Greenland's West coast fjords and towering mountains.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=GOING_GREENLAND_TRAILER_2023.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>REEL ROCK: DNA</strong><br />
            <p style="margin: 0px; font-size: 90%;">French sport climber Seb Bouin has been quietly working his way through elite grades, culminating in his attempt to establish a long pitch through an overhanging cave in the Verdon Gorge of France - possibly the most difficult route in the world!</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=Reel+Rock+-+DNA+-+Social+Media+Trailer.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
        </div>
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },     
    {
      title: "Bob Dylan",
      subtitle: "Rough And Rowdy Ways Tour",
      date: new Date(2023, 10, 30),
      dateFormatted: "Thursday November 30th 2023",
      dateFormattedShort: "Nov 30th",
      timeFormatted: "8:00 pm",
      location: "Keith Albee",
      tickets: "https://www.ticketmaster.com/bob-dylan-rough-and-rowdy-ways-huntington-west-virginia-11-30-2023/event/16005F36E5303854",
      website: "https://www.bobdylan.com/on-tour/",
      description: "",
      specialEvent: true,
      content: `
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },  
    {
      title: "Amos Lee",
      subtitle: "Live in Concert with Special guest, Julia Pratt",
      date: new Date(2024, 4, 13),
      dateFormatted: "Monday May 13th 2024",
      dateFormattedShort: "May 13th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Performing Arts Center",
      tickets: "https://www.ticketmaster.com/event/1600603EE6D44708",
      website: "https://www.amoslee.com/",
      trailer: "https://www.youtube.com/watch?v=CE9Ey89zzIk&list=OLAK5uy_mf02mtN9LSa8bcp8V4TFm6sbMIkiY3iq8&index=2",
      description: "With his laid-back vocal delivery and acoustic songwriting, <strong>Amos Lee</strong> draws inspiration from soul music, contemporary jazz, and 70s folk artists like <strong>James Taylor</strong>.",
      content: `
        <p>
        The Philadelphia native first began performing while in college. After graduating    
        with a degree in English, he taught elementary school before deciding to pursue a 
        music career full-time. While bartending at local music bars, Lee honed his 
        songwriting skills,performing at open mic nights, and meeting industry contacts    
        - one of which happened to be <strong>Bob Dylan's</strong> manager.    
        </p>
        <p>
          He landed some high-profile gigs as an opening act, including an extended tour with pianist/vocalist 
          <strong>Norah Jones</strong>. Amos Lee has a voice that is something special. <strong>Lucinda Williams</strong> and <strong>Paul Simon</strong> are fans 
          and <strong>Adele</strong>, who picked him out to be her support act on tour, says: “Amos is a magnificent singer, 
          incredible. His voice blows me away.” Lee has also toured with The <strong>Dave Matthews Band</strong>, <strong>Avett Brothers</strong>
          and <strong>Zac Brown Band</strong> and has a sold-out date at <strong>Red Rocks Amphitheatre</strong> later this summer with <strong>The Indigo Girls</strong>   
        </p>
        <p>Special Guest: Julia Pratt</p>
        <p>Julia Pratt is a 22 year old singer-songwriter based in Philadelphia.</p>
        <p>A songwriter at heart, Julia's music blends pop, jazz, R&B, and folk, with dashes of electronic productions.</p>
      `,
      photos: [
        "juliapratt"
      ],
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: []
    },      
]

for (let show of shows) {
    if (!show.name)
        show.name = show.title.toLowerCase().replace(/\ /g, "_").replace(/\'/g, "").replace(/\!/g, "").replace(/\:/g, "").replace(/\./g, "");

    show.url = "/shows/" + show.name;

    if (!show.festival || show.poster)
      show.poster = process.env.PUBLIC_URL + "/shows/" + show.name + "/poster2.jpg?v4";

    if (show.photos)
      show.photos = show.photos.map(p => process.env.PUBLIC_URL + "/shows/" + show.name + "/" + p + ".jpg?v3");

    if (show.tickets && show.tickets.length == 0)
        show.tickets = null;

    if (show.download && show.download.length > 0)
        show.download = process.env.PUBLIC_URL + "/shows/" + show.name + "/" + show.download;      

    if (show.festival && show.shows) {
        for (let festivalShow of show.shows) {
            festivalShow.name = festivalShow.title.toLowerCase().replace(/\ /g, "_");
            festivalShow.poster = process.env.PUBLIC_URL + "/shows/" + show.name + "/" + festivalShow.name.replace(/\'/g, "").replace(/\:/g, "") + ".jpg";
            
            if (show.schedule) {
              festivalShow.schedule = [];

              for (const day in show.schedule) {
                const daySchedule = show.schedule[day];

                for (const time in daySchedule) {
                  if (daySchedule[time] == festivalShow.title) {
                    festivalShow.schedule.push(day + " - " + time);
                  }
                }
              }
            }
        }
    }

    if (show.trailer && show.trailer.length > 0 && show.trailer.indexOf("v=") != -1) {
      let videoId = show.trailer.split('v=')[1];
      let ampersandPosition = videoId.indexOf('&');

      if(ampersandPosition != -1) {
        videoId = videoId.substring(0, ampersandPosition);
      }     

      show.youtubeVideoId = videoId;
    }
}

let sortedShows = shows.slice();

sortedShows.sort(function(a,b){
    return a.date - b.date;
});

export function getAllShows() {
    return sortedShows;
}

export function getShowByName(name) {
    return shows.find(s => s.name == name);
}

console.log({sortedShows})